import Factory from '../utils/factory'
import Shared from './shared'


export default Factory({
  id: null,
  name: null,
  internalName: null,
  customFields: null,
  customFieldsConfig: [],
  themeLayout: [],
  ...Shared(),
})
